import { Font } from "@react-pdf/renderer";

Font.register({
  family: "NotoSansJP",
  fonts: [
    { src: "/assets/fonts/NotoSansJP-Regular.otf", fontWeight: 400 },
    { src: "/assets/fonts/NotoSansJP-Medium.otf", fontWeight: 500 },
    { src: "/assets/fonts/NotoSansJP-Bold.otf", fontWeight: 700 },
  ],
});

// Remove hyphenation
Font.registerHyphenationCallback((word) => ["", word, ""]);
